import { message } from 'antd';
import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects'
import { FETCH_ALL_RIS_USERS, FETCH_ALL_RIS_USERS_SUCCESS, FETCH_ALL_RIS_USERS_ERROR, FETCH_RIS_WITH_MIP, FETCH_RIS_WITH_MIP_ERROR, FETCH_RIS_WITH_MIP_SUCCESS } from '../../actions/admin/risActions';
import { fetchRisMipsAPI, fetchAllRisAPI } from '../../../services/ris-service';
import _ from 'lodash';

function* fetchRisMips({ }) {
    try {
        const response = yield call(fetchRisMipsAPI);
        if (response.success) {
            yield put({ type: FETCH_RIS_WITH_MIP_SUCCESS, risMips: _.cloneDeep(response.data) })
        } else {
            yield put({ type: FETCH_RIS_WITH_MIP_ERROR, error: response.error })
            message.error('Failed to fetch RIS users!');
        }
    } catch (error) {
        yield put({ type: FETCH_RIS_WITH_MIP_ERROR, error })
        message.error('Failed to fetch RIS users!');
    }
}

function* fetchAllRis({ }) {
    try {
        const response = yield call(fetchAllRisAPI);
        if (response.success) {
            yield put({ type: FETCH_ALL_RIS_USERS_SUCCESS, ris: _.cloneDeep(response.ris) })
        } else {
            yield put({ type: FETCH_ALL_RIS_USERS_ERROR, error: response.error })
            message.error('Failed to fetch RIS!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_RIS_USERS_ERROR, error })
        message.error('Failed to fetch RIS!');
    }
}

function* risWatcher() {
    yield takeEvery(FETCH_RIS_WITH_MIP, fetchRisMips)
    yield takeEvery(FETCH_ALL_RIS_USERS, fetchAllRis)

}

export default function* rootSaga() {
    yield all([
        risWatcher()
    ])
}